(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(min-width: 750px)');

    const syncFooterMenus = () => {
      document.querySelectorAll('.footer--eden__menu').forEach((menu) => {
        if (media.matches) {
          menu.setAttribute('open', '');
        } else {
          menu.removeAttribute('open');
        }
      });
    };

    syncFooterMenus();
    media.addEventListener('change', syncFooterMenus);
    document.addEventListener('shopify:section:load', syncFooterMenus);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  function mountReferenceMedia(container) {
    container.querySelectorAll('[data-reference-media-pool]').forEach((pool) => {
      const page = pool.closest('[data-reference-page]');
      if (!page) return;

      // A layout may expose several anchors for one slot (one image per card).
      // Items then fill those anchors in block order; a single anchor keeps the
      // original behaviour of collecting every image for the slot.
      const used = {};

      pool.querySelectorAll('[data-reference-media-target]').forEach((item) => {
        const slot = item.dataset.referenceMediaTarget;
        const anchors = page.querySelectorAll(`[data-reference-media-slot="${slot}"]`);
        if (!anchors.length) return;

        const index = used[slot] || 0;
        used[slot] = index + 1;
        anchors[Math.min(index, anchors.length - 1)].appendChild(item);
      });
    });
  }

  // Search box and category tabs filter the same list, so both write their
  // state onto the page and one pass decides what stays visible.
  function applyReferenceFilters(page) {
    const query = (page.dataset.referenceQuery || '').trim().toLowerCase();
    const tab = page.dataset.referenceTab || '';
    let visible = 0;

    page.querySelectorAll('[data-reference-filter-item]').forEach((item) => {
      const matchesQuery = query === '' || item.textContent.toLowerCase().includes(query);
      const matchesTab = tab === '' || item.dataset.category === tab;
      item.hidden = !(matchesQuery && matchesTab);
      if (!item.hidden) visible += 1;
    });

    const empty = page.querySelector('[data-reference-empty]');
    if (empty) empty.hidden = visible !== 0;
  }

  function bindReferenceFilters(container) {
    container.querySelectorAll('[data-reference-filter]').forEach((filter) => {
      if (filter.dataset.referenceFilterBound === 'true') return;
      filter.dataset.referenceFilterBound = 'true';

      const page = filter.closest('[data-reference-page]');
      if (!page) return;

      filter.addEventListener('input', () => {
        page.dataset.referenceQuery = filter.value;
        applyReferenceFilters(page);
      });
    });

    container.querySelectorAll('[data-reference-tab]').forEach((tab) => {
      if (tab.dataset.referenceTabBound === 'true') return;
      tab.dataset.referenceTabBound = 'true';

      const page = tab.closest('[data-reference-page]');
      if (!page) return;

      tab.addEventListener('click', () => {
        page.dataset.referenceTab = tab.dataset.referenceTab;
        page.querySelectorAll('[data-reference-tab]').forEach((other) => {
          const active = other === tab;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        applyReferenceFilters(page);
      });
    });
  }

  mountReferenceMedia(document);
  bindReferenceFilters(document);
  document.addEventListener('shopify:section:load', (event) => {
    mountReferenceMedia(event.target);
    bindReferenceFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
